import UserInput from '@/components/_custom/UserInput/userInput'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DialogActions from '@/components/_custom/DialogActions/DialogActions'
import styles from '../../occasionalSlotForm.module.scss'
import { t } from 'i18next'

interface SlotCountFieldProps {
    value: number
    onChange: (value: number) => void
    min?: number
    max: number
    error?: boolean
    className?: string
}

export default function SlotCountField({ value, onChange, min = 1, max, error, className }: SlotCountFieldProps) {
    return (
        <UserInput
            label={t('seatsNumber')}
            type='number'
            setValue={(value: string) => onChange(Number(value))}
            value={String(value)}
            minNumber={min}
            maxNumber={max}
            verify='number'
            className={`${styles.UserInput} ${className}`}
            externalError={error}
        />
    )
}

interface SlotCountPopupProps extends SlotCountFieldProps {
    handleClose: () => void
    onConfirm: () => void
}

export function SlotCountPopup({ handleClose, onConfirm, ...fieldProps }: SlotCountPopupProps) {
    const { value, min = 1, max } = fieldProps
    const isValid: boolean = Number.isInteger(value) && value >= min && value <= max

    function handleConfirm(): void {
        if (!isValid) return
        handleClose()
        onConfirm()
    }

    return (
        <>
            <p>{t('editOccasionalSlotMessage')}</p>
            <SlotCountField {...fieldProps} error={!isValid} className='centered' />
            <DialogActions>
                <ButtonTextIcon type='cancel' onClick={handleClose} nowrap />
                <ButtonTextIcon type='confirm' onClick={handleConfirm} disabled={!isValid} nowrap />
            </DialogActions>
        </>
    )
}
